import React, { useState, useEffect } from 'react';
import { isAuthenticated } from "../../store/action/auth";
import { trackEvent } from "../../services/analytics";
import Freshchat from "../../components/atoms/FreshChat";
import JotformEmbed from 'react-jotform-embed';
import { connect } from 'react-redux'
import { useDispatch } from "react-redux";
import {
    getWallet
} from "../../store/action/billing";

const PostpaidForm = (props) => {
    const dispatch = useDispatch();
    const [ loading, setLoading ] = useState(true);

   const { user , token } = isAuthenticated();

   useEffect(() => {
       _fetchData()
   }, []);

   const _fetchData = async () => {
       try {
            dispatch(getWallet(token));
           setLoading(false)
       } catch (e) {
           console.log (e);
           alert("Gagal ambil data akun. Mohon ulangi kembali.")
       }
   };
   
   return (
       <div>
            <JotformEmbed src="https://form.jotform.com/203054975854463" />
       </div>
   )
};

export default connect(state => ({ wallet: state.wallet}), {})(PostpaidForm)
